export default __webpack_public_path__ + "static/media/soon.83e00062.gif";